<div class="bg-white px-4 py-3">
  <form class="d-flex justify-content-between align-items-center">
    <p-select
      [items]="services"
      [selectedItem]="serviceSelected"
      size="small"
      class="col-2"
      (selected)="onServiceSelected($event)"
    ></p-select>
    <p-select
      [items]="typesDeBiens"
      [selectedItem]="typeDeBienSelected"
      size="small"
      class="col-2"
      (selected)="onTypeDeBienSelected($event)"
    ></p-select>
    <p-input
      [formControl]="this.searchForm.controls.localisation"
      id="localisation"
      name="localisation"
      placeholder="Ex : Marseille"
      size="small"
      class="col-4"
      (ngModelChange)="onLocalisationChange($event)"
    ></p-input>

    <p-button
      label="Rechercher"
      level="primary"
      type="button"
      size="small"
      (click)="search()"
    ></p-button>
    <p-button
      label="Réinitialiser les filtres"
      level="secondary"
      type="button"
      size="small"
      (click)="resetFilters()"
    ></p-button>
  </form>
</div>
